import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';

const styles = css`
.full-width-headline-left {
  width: 100%;
  position: relative;
  height: 72px;
  text-align: left;
  margin: 0 0 60px;

  @media (max-width: 767px) {
    margin: 0 0 15px;
    height: auto;
  }

  .lines {
    position: absolute;
    top: 22px;
    height: 12px;
    opacity: 0.1;
    background-image: url("/images/wood-bg-horizontal.jpg");
    z-index: 1;
    width: 100%;
    @media (max-width: 767px) {
      display: none;
    }
  }

  h2 {
    position: relative;
    z-index: 2;
    display: inline-block;
    padding: 0 30px;
    font-size: 72px;
    line-height: 72px;
    background-color: ${colors.white};
    font-family: ${typography.Serif};
    color: ${colors.black};
    @media (max-width: 767px) {
      padding: 0;
      font-size: 36px;
      line-height: 1.2;
    }
  }

  h3 {
    position: relative;
    z-index: 2;
    display: inline-block;
    padding: 0 30px;
    font-size: 42px;
    line-height: 72px;
    background-color: ${colors.white};
    font-family: ${typography.Serif};
    color:${colors.color2};
    @media (max-width: 767px) {
      padding: 0;
      font-size: 28px;
      line-height: 1.2;
    }
  }

  h4 {
    position: relative;
    z-index: 2;
    display: inline-block;
    padding: 0 30px;
    font-size: 36px;
    line-height: 72px;
    background-color: ${colors.white};
    font-family: ${typography.Serif};
    color: ${colors.black};
    @media (max-width: 767px) {
      padding: 0;
      font-size: 24px;
      line-height: 1.2;
    }
  }
}
`;

function FullWidthHeadlineLeft({ h2, h3, h4 }) {
  return (
    <div className={styles}>
      <div className="full-width-headline-left">
        <div className="container">
          { h2 && <h2>{h2}</h2>}
          { h3 && <h3>{h3}</h3>}
          { h4 && <h4>{h4}</h4>}
        </div>
        <div className="lines" />
      </div>
    </div>
  );
}

FullWidthHeadlineLeft.propTypes = {
  h2: PropTypes.string,
  h3: PropTypes.string,
  h4: PropTypes.string,
};

FullWidthHeadlineLeft.defaultProps = {
  h2: undefined,
  h3: undefined,
  h4: undefined,
};

export default FullWidthHeadlineLeft;



// WEBPACK FOOTER //
// ./src/components/FullWidthHeadlineLeft.js